'use client';

import { motion } from 'framer-motion';
import React from 'react';

interface SuccessMessageProps {
  show: boolean;
  onClose: () => void;
  message: string;
}

export const SuccessMessage = React.memo(
  ({ show, onClose, message }: SuccessMessageProps) => {
    if (!show) return null;

    return (
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        className='fixed bottom-4 left-1/2 z-50 -translate-x-1/2 transform'
      >
        <div className='rounded-lg bg-green-100 px-6 py-3 shadow-lg'>
          <div className='flex items-center space-x-2'>
            <svg
              className='h-5 w-5 text-green-500'
              viewBox='0 0 20 20'
              fill='currentColor'
            >
              <path
                fillRule='evenodd'
                d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
                clipRule='evenodd'
              />
            </svg>
            <p className='text-sm font-medium text-green-800'>{message}</p>
            <button
              onClick={onClose}
              className='ml-4 text-green-600 hover:text-green-800'
            >
              <svg className='h-5 w-5' viewBox='0 0 20 20' fill='currentColor'>
                <path
                  fillRule='evenodd'
                  d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                  clipRule='evenodd'
                />
              </svg>
            </button>
          </div>
        </div>
      </motion.div>
    );
  }
);

SuccessMessage.displayName = 'SuccessMessage';
